<template>
  <div :class="['simple-progress-bar-container', props.status]">
    <div class="info-container">
      <div class="info-container-item">
        <span v-if="props.icon" :class="['info-container-item-icon', props.icon]" />
        <span class="info-container-item-text">{{ props.text }}</span>
      </div>
    </div>

    <v-progress-linear
      :indeterminate="computedIndeterminate"
      rounded
      :color="vars.progress_bar_success"
      :background-color="computedBackgroundColor"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { vars } from '@/styles/styleVars'
import { Status } from './types/LfProgressBarTypes'

// PROPS
const props = defineProps({
  text: {
    type: String,
    required: false
  },
  status: {
    type: String as PropType<Status>,
    required: false,
    default: Status.LOADING
  },
  icon: {
    type: String,
    required: false
  }
})

// COMPUTED
const computedIndeterminate = computed(() => props.status === Status.LOADING)

const computedBackgroundColor = computed(() => {
  switch (props.status) {
    case Status.LOADED:
      return vars.progress_bar_success
    case Status.ERROR:
      return vars.progress_bar_error
    default:
      return vars.progress_bar_default_color
  }
})

</script>

<style lang="scss" scoped>
.simple-progress-bar-container {
  margin-top: $spacing-md;

  .info-container {
    display: flex;
    align-items: center;
    gap: $spacing-xxs;
    align-self: stretch;
    margin-bottom: $spacing-xs;

    &-item {
      display: flex;
      align-items: flex-start;
      flex: 1 0 0;

      &-icon {
        display: block;
        width: 15px;
        height: 15px;
        line-height: inherit;
      }

      &-text {
        @include milano-medium-18;
        color: $neutral-grey-900;
        text-align: right;
        margin-left: $spacing-xs;
      }
    }
  }

  &.Loaded {
    .info-container {
      .status-container {
        .status-info {
          color: $tertiary-seaGreen-200;
        }

        .status-icon::before {
          color: $tertiary-seaGreen-200;
        }
      }
    }
  }
}
</style>
